<section class="surface">
	<lvr-heading>
		{{ 'user.user_view.user' | transloco }}
		<div ngProjectAs="button-content" style="display: flex; gap: 0.5rem; align-items: center">
			<lvr-button
				variant="primary"
				[label]="'database_view.assignments.toolbar.reset' | transloco"
				[type]="'button'"
				(clicked)="resetAll()"
				icon="filter_alt_off"
			></lvr-button>
			@if (canCreateUsers()) {
				<lvr-button
					variant="primary"
					[label]="'user.user_view.user' | transloco"
					[ariaLabel]="'user.user_view.add_user' | transloco"
					[type]="'button'"
					(clicked)="openCreate()"
					icon="add"
				></lvr-button>
			}
		</div>
	</lvr-heading>

	@if (totalItems() >= 0 || hasActiveSearch() || loading()) {
		<div class="progress-slot">
			<mat-progress-bar mode="indeterminate" [class.is-hidden]="!loading()"></mat-progress-bar>
		</div>
		<div class="user-table-container">
			<div class="table-wrap">
				<table mat-table [dataSource]="displayedUsers()" class="mat-elevation-z2">
					<!-- Status Column -->
					<ng-container matColumnDef="status">
						<th mat-header-cell *matHeaderCellDef>
							<div class="th-inline">
								<span class="th-label" [matTooltip]="'user.table.status' | transloco">{{
									'user.table.status' | transloco
								}}</span>
							</div>
							<div class="th-filter-inline">
								<div class="status-segment" role="group" aria-label="Status filter">
									<button
										type="button"
										class="status-segment-option"
										[class.is-active]="showActiveUsers()"
										[attr.aria-pressed]="showActiveUsers()"
										(click)="setStatusFilter(true)"
									>
										Aktiv
									</button>
									<button
										type="button"
										class="status-segment-option"
										[class.is-active]="!showActiveUsers()"
										[attr.aria-pressed]="!showActiveUsers()"
										(click)="setStatusFilter(false)"
									>
										Deaktiviert
									</button>
								</div>
							</div>
						</th>
						<td mat-cell *matCellDef="let user">
							<span class="cell-text">{{ user.isActive ? 'Aktiv' : 'Deaktiviert' }}</span>
						</td>
					</ng-container>
					<!-- First Name Column -->
					<ng-container matColumnDef="firstName">
						<th mat-header-cell *matHeaderCellDef>
							<div class="th-inline">
								<span class="th-label" [matTooltip]="'base.field.first_name' | transloco">{{
									'base.field.first_name' | transloco
								}}</span>
								<button
									matIconButton
									class="btn-tertiary"
									[matMenuTriggerFor]="sortMenu"
									(click)="setActiveSortField('firstName')"
								>
									<mat-icon>swap_vert</mat-icon>
								</button>
							</div>
							<div class="th-filter-inline">
								<input
									class="th-filter-input"
									(click)="$event.stopPropagation()"
									[value]="filterSearch()['firstName']"
									(input)="setFilterSearch('firstName', $any($event.target).value)"
									[placeholder]="'base.field.first_name' | transloco"
								/>
							</div>
						</th>
						<td mat-cell *matCellDef="let user">
							<span class="cell-text">{{ user.firstName }}</span>
						</td>
					</ng-container>

					<!-- Last Name Column -->
					<ng-container matColumnDef="lastName">
						<th mat-header-cell *matHeaderCellDef>
							<div class="th-inline">
								<span class="th-label" [matTooltip]="'base.field.last_name' | transloco">{{
									'base.field.last_name' | transloco
								}}</span>
								<button
									matIconButton
									class="btn-tertiary"
									[matMenuTriggerFor]="sortMenu"
									(click)="setActiveSortField('lastName')"
								>
									<mat-icon>swap_vert</mat-icon>
								</button>
							</div>
							<div class="th-filter-inline">
								<input
									class="th-filter-input"
									(click)="$event.stopPropagation()"
									[value]="filterSearch()['lastName']"
									(input)="setFilterSearch('lastName', $any($event.target).value)"
									[placeholder]="'base.field.last_name' | transloco"
								/>
							</div>
						</th>
						<td mat-cell *matCellDef="let user">
							<span class="cell-text">{{ user.lastName }}</span>
						</td>
					</ng-container>

					<!-- Business Email Column -->
					<ng-container matColumnDef="email">
						<th mat-header-cell *matHeaderCellDef>
							<div class="th-inline">
								<span class="th-label" [matTooltip]="'base.field.email' | transloco">{{
									'base.field.email' | transloco
								}}</span>
								<button
									matIconButton
									class="btn-tertiary"
									[matMenuTriggerFor]="sortMenu"
									(click)="setActiveSortField('email')"
								>
									<mat-icon>swap_vert</mat-icon>
								</button>
							</div>
							<div class="th-filter-inline">
								<input
									class="th-filter-input"
									(click)="$event.stopPropagation()"
									[value]="filterSearch()['email']"
									(input)="setFilterSearch('email', $any($event.target).value)"
									[placeholder]="'base.field.email' | transloco"
								/>
							</div>
						</th>
						<td mat-cell *matCellDef="let user">
							<span class="cell-text">{{ user.email || '-' }}</span>
						</td>
					</ng-container>

					<!-- Actions Column -->
					<ng-container matColumnDef="actions">
						<th mat-header-cell *matHeaderCellDef>
							<div class="th-inline">
								<span>{{ 'base.field.actions' | transloco }}</span>
							</div>
							<div class="th-filter-inline actions-filter-placeholder"></div>
						</th>
						<td mat-cell *matCellDef="let user">
							<div class="actions-row">
								<button
									matIconButton
									class="btn-tertiary"
									[attr.aria-label]="'user.table.trigger_edit' | transloco"
									[title]="'user.table.trigger_edit' | transloco"
									(click)="openEdit(user, $event)"
									[disabled]="!canEditUsers()"
								>
									<mat-icon aria-hidden="true">edit</mat-icon>
								</button>
								@if (!user.isActive && canEditUsers()) {
									<button
										matIconButton
										class="btn-tertiary"
										(click)="triggerReactivate(user, $event)"
										[title]="'user.table.trigger_reactivate' | transloco"
										[attr.aria-label]="'user.table.trigger_reactivate' | transloco"
									>
										<mat-icon>how_to_reg</mat-icon>
									</button>
								} @else if (canEditUsers()) {
									<button
										matIconButton
										class="btn-tertiary"
										(click)="triggerDeactivate(user, $event)"
										[title]="'user.table.trigger_deactivate' | transloco"
										[attr.aria-label]="'user.table.trigger_deactivate' | transloco"
									>
										<mat-icon>block</mat-icon>
									</button>
								}
								@if (canDeleteUsers()) {
									<button
										matIconButton
										class="btn-tertiary"
										(click)="triggerDelete(user, $event)"
										[title]="'user.table.trigger_delete' | transloco"
									>
										<mat-icon>delete</mat-icon>
									</button>
								}
							</div>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr
						mat-row
						tabindex="0"
						(click)="openDetails(row)"
						(keydown.enter)="openDetails(row)"
						[class]="!row.isActive ? 'inactive' : ''"
						*matRowDef="let row; columns: displayedColumns"
					></tr>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
							{{ 'user.table.no_search_results' | transloco }}
						</td>
					</tr>
				</table>
			</div>

			<lvr-paginator
				[length]="paginatorLength()"
				[pageSize]="pageSize()"
				[pageIndex]="pageIndex()"
				[showFirstLastButtons]="true"
				[hidePageSize]="false"
				[disabled]="loading()"
				preferenceKey="user-list"
				(page)="handlePageEvent($event)"
			>
			</lvr-paginator>
		</div>
	} @else {
		<div class="no-users">
			<p>{{ 'user.table.no_entries' | transloco }}</p>
		</div>
	}
</section>

<mat-menu #sortMenu="matMenu">
	<button mat-menu-item class="sort-menu-item" (click)="setSort(activeSortField(), 'asc')">
		<span class="sort-menu-label">{{ sortLabel('asc') | transloco }}</span>
		<mat-icon class="sort-check" [class.is-hidden]="!isSortOptionActive(activeSortField(), 'asc')">check</mat-icon>
	</button>
	<button mat-menu-item class="sort-menu-item" (click)="setSort(activeSortField(), 'desc')">
		<span class="sort-menu-label">{{ sortLabel('desc') | transloco }}</span>
		<mat-icon class="sort-check" [class.is-hidden]="!isSortOptionActive(activeSortField(), 'desc')">check</mat-icon>
	</button>
</mat-menu>
